import React ,{ useEffect, useRef, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { connect } from 'react-redux'
import Box from '@mui/material/Box';
import {List as FixedSizeList } from 'react-virtualized';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { setLeftPage } from '../../../actions/ui'
import BookmarkBorderSharpIcon from '@mui/icons-material/BookmarkBorderSharp';
import BookmarkSharpIcon from '@mui/icons-material/BookmarkSharp';
import { setOpenLogin, setLeftBoothList, setBookmardUpdated, setOpenCompanyProfile, setOpenUnassignedProfile, setOpenBoothList, resetUI } from '../../../actions/ui'
import { setActive3dObject, setBookmarkList, setBoothFileList, resetMain, setActiveMapKey } from '../../../actions/main';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import axiosInstance from '../../../utils/axiosInstance.js'
import qs from 'qs'
import {checkIfSelectable, setActiveObject, highlightObject, deselectHighlightObject} from '../../../utils/CanvasTool'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import Fade from '@mui/material/Fade';
import { getTokenPlanner } from '../../../utils/Common'
import { API_URL, ESHOW_URL } from '../../../config.js'

var highlightedBooths = []
function Index(props) {
  let standardSearchOptions = props.searchbox?.searchOptions?.STANDARD??[]
  let keySelect = props.searchbox?.searchKeySelect
  let pulldownValue = props.searchbox?.searchPulldownValue
  let searchInputValue = props.searchbox?.searchInputValue
  var selectedAdvancedFilterOptions = props.searchbox.selectedAdvancedFilterOptions

  useEffect(() => {
    return () => {
      for(var i = 0; i < highlightedBooths.length; i++){
        var booth = highlightedBooths[i]
        deselectHighlightObject(booth, props.main);
      }
      props.main.mainCanvas.renderAll();
    };
  }, [props.ui.leftBoothList])

  
  const callBookmarkApi= async (exhibitor, value)=>{
    const _token = getTokenPlanner();
    var BOOKMARKS = props.main.bookmarkList?props.main.bookmarkList:[]
    if(value){
      BOOKMARKS = [
        ...BOOKMARKS,
        {
          COMPANY_NAME: exhibitor?.company?exhibitor?.company:(exhibitor?.COMPANY_NAME?exhibitor?.COMPANY_NAME:""),
          NOTES:"",
          STATUS:'',
          BOOTHS:exhibitor.BOOTHS,
          EXHIBITOR_KEY:exhibitor?.EXHIBITOR_KEY?exhibitor?.EXHIBITOR_KEY:"" 
        }
      ]
    }
    else{
      BOOKMARKS = BOOKMARKS.filter((item, index) => `${item.EXHIBITOR_KEY}` !== `${exhibitor.EXHIBITOR_KEY}`)
    }
    
    var postData =
    {
      SUCCESS:true,
      BOOKMARKS:BOOKMARKS
    };

    var formdata = {
      query:`${ESHOW_URL()}?method=putPlanner&token=${_token}`,
      postData: postData,
      returnResponse: true
    }
    var data = qs.stringify({
        request: JSON.stringify(formdata)
    });
    const options = {
      headers: {
        'body': '[{"company:","test"}]', 
        'Content-Type': 'application/json'
      }
    }
    var url = `${ESHOW_URL()}?method=putPlanner&token=${_token}`
    axiosInstance.post(url, JSON.stringify(postData), options).then(async res=>{
      const eshowResponse = res.data;
      if(eshowResponse.SUCCESS == true){
      }
      else{
        props.setOpenSnack(true);
        props.setSnackMsg(eshowResponse.MESSAGE?eshowResponse.MESSAGE:"Failed to save bookmark");
      }
      props.setBookmarkList(BOOKMARKS)
    }).catch(error => {
        console.log("error", error);
    })
  }

  const doBookmark = (exhibitor)=>{
    if(exhibitor){
      if(!exhibitor?.EXHIBITOR_KEY){
        return false;
      }
      const _token = getTokenPlanner();
      if((props.role !='admin') && (!_token || !_token)){
        props.setOpenLogin(true)
        return false;
      }
      var newBoothList = [...props.ui.leftBoothList];
      for(var i =  0; i< newBoothList.length; i++){
        if(`${newBoothList[i]['EXHIBITOR_KEY']}` == `${exhibitor.EXHIBITOR_KEY}`){
          callBookmarkApi(exhibitor, !newBoothList[i]['bookmark'])
          newBoothList[i]['bookmark'] = !newBoothList[i]['bookmark']
        }
      }
      props.setLeftBoothList(newBoothList)
      // props.setBookmardUpdated(true)
    }
  }

  const switchMap = (exhibitor)=>{
    let exhibitor_map_key = exhibitor.MAP_KEY
    var boothFileList = props.main.boothFileList;
    if(props.role == "admin"){
      var tmp = [...boothFileList];
      for(var i = 0; i <tmp.length; i++){
          if(tmp[i]['KEY_ID'] == exhibitor_map_key){
              tmp[i] = {...tmp[i], active:!tmp[i]['active']};
          }
          else{
            tmp[i] = {...tmp[i], active:false}
          }
      }
      deselectHighlightObject(highlightedBooths[i], props.main);
      props.resetMain();
      props.resetUI();
      // props.main.mainCanvas.off('object:moving')
      setTimeout(function(){
        props.setBoothFileList(tmp)
      }, 300)
      return;
    }
    else{
      props.setActiveMapKey(exhibitor_map_key)
      return;
    }
  }
  const isSyntheticUnassignedRow = (exhibitor) => exhibitor?.rowType === 'unassigned';

  const resolveBoothForRow = (exhibitor) => {
    if (isSyntheticUnassignedRow(exhibitor) && exhibitor?.boothObject) {
      return exhibitor.boothObject;
    }
    if (exhibitor?.booth && exhibitor.booth !== '') {
      return getBoothByNumber(exhibitor.booth);
    }
    return exhibitor?.obj || null;
  }
  const onClickItem = (boothParam, exhibitor)=>{
    props.main.mainCanvas.discardActiveObject().renderAll()
    props.setOpenCompanyProfile(false)
    let exhibitor_map_key = exhibitor.MAP_KEY
    const active_booth_file = props.main.active_booth_file
    if(exhibitor_map_key){
      if(active_booth_file && active_booth_file.KEY_ID == exhibitor_map_key){
      }
      else{
        switchMap(exhibitor)
        return;
      }    
    }
    if(isSyntheticUnassignedRow(exhibitor)){
      var booth = null
      if(typeof boothParam === 'object' && boothParam !== null){
        booth = boothParam
      }
      else{
        booth = getBoothByNumber(boothParam)
      }
      if(!booth || (booth.get('class') != 'booth' && booth.get('class') != 'booth-group')){
        return;
      }
      var childObjects = booth.getObjects('rect');
      for(var j = 0; j< childObjects.length; j++){
        if(childObjects[j].get('class') == 'color'){
            childObjects[j].set({fill: 'rgb(213, 5, 48)'})
            props.main.mainCanvas.renderAll();
            break;
        }
      }
      props.setOpenCompanyProfile(false)
      props.setOpenUnassignedProfile({booth:booth, open:true})

      for(var i = 0; i < highlightedBooths?.length; i++){
        deselectHighlightObject(highlightedBooths[i], props.main);
      }
      highlightedBooths = [];
      highlightObject(booth, props.main, true);
      highlightedBooths.push(booth);
      props.main.mainCanvas.renderAll();
    }
    else{
      if(!boothParam) {
        props.setOpenUnassignedProfile(false)
        props.setOpenCompanyProfile({booth:{exhibitors:[exhibitor]}, open:true})        

        for(var i = 0; i < highlightedBooths?.length; i++){
          deselectHighlightObject(highlightedBooths[i], props.main);
        }
        props.main.mainCanvas.renderAll();
        return;
      }
      var booth = null
      if(typeof boothParam === 'object' && boothParam !== null){
        booth = boothParam
      }
      else{
        booth = getBoothByNumber(boothParam)
      }

      if(booth && (booth.get('class') == 'booth' || booth.get('class') == 'booth-group')){    
        var priced = false
        if(booth.get('sold')){
            priced = true
        }
        var childObjects = booth.getObjects('rect');
        for(var j = 0; j< childObjects.length; j++){
            if(childObjects[j].get('class') == 'color'){
                childObjects[j].set({fill: 'rgb(213, 5, 48)'})
                props.main.mainCanvas.renderAll();
                break;
            }
        }
        props.setOpenUnassignedProfile(false)
        props.setOpenCompanyProfile({booth:{exhibitors:[exhibitor]}, open:true})        

        for(var i = 0; i < highlightedBooths?.length; i++){
          deselectHighlightObject(highlightedBooths[i], props.main);
        }
        props.main.mainCanvas.renderAll();

        var companyBooths = getBoothByCompany(booth.company)
        highlightedBooths = [];
        for(var j = 0; j < companyBooths.length; j++){
          if(companyBooths[j]){
            highlightObject(companyBooths[j], props.main, true);
            highlightedBooths.push(companyBooths[j])
          }
        }
        props.main.mainCanvas.renderAll();

      } 
    }
  }

  const getBoothByNumber = (number)=>{
    var objects = props.main.mainCanvas.getObjects('group')
    for(var i = 0; i < objects.length; i++){
      if(checkIfSelectable(objects[i])){
        if(objects[i].class=='booth'){
          var exhibitors = objects[i].exhibitors;
          if(objects[i].booth_number == number){
            return objects[i]
          }
        }
      }
    }
    return null
  }

  
  const getBoothByCompany = (company)=>{
    var outputs = [];
    var objects = props.main.mainCanvas.getObjects('group')
    for(var i = 0; i < objects.length; i++){
      if(checkIfSelectable(objects[i])){
        if(objects[i].class=='booth'){
          if(objects[i].company == company){
            outputs.push(objects[i])
          }
        }
      }
    }
    return outputs
  }

  function rowRenderer({
      key, // Unique key within array of rows
      index, // Index of row within collection
      isScrolling, // The List is currently being scrolled
      isVisible, // This row is visible within the List (eg it is not an overscanned row)
      style, // Style object to be applied to row (to position it)
      rowItems
  }) {
    // var leftBoothList = props.ui.leftBoothList
    if(props.bookmark){
      rowItems = rowItems.filter((booth)=>{
        return booth.bookmark
      })
    }
    var sales_bookmarks_show = true
    if(props.main.showSetup?.PUBLIC?.BOOKMARKS == 'hide'){
      sales_bookmarks_show = false
    }

    var exhibitor =rowItems[index]
    if(exhibitor){
      return (
        <ListItem 
          button 
          key={key} style={style}
          secondaryAction={
            <>
              { exhibitor.booth?.signed_pdf && props.role == "admin" && 
                  <IconButton edge="end"  download href={API_URL()+"/content/contract/signature/"+exhibitor.exhibitor?.signed_pdf} >
                    {
                      <PictureAsPdfIcon/>
                    }
                  </IconButton>
              }

              { exhibitor['booth'] !='' && sales_bookmarks_show && exhibitor?.EXHIBITOR_KEY && 
                <IconButton edge="end" onClick={()=>{ doBookmark(exhibitor)}}>
                  {
                    exhibitor.bookmark?
                      <BookmarkSharpIcon style={{color:'#e54839'}}/>
                    :
                      <BookmarkBorderSharpIcon/>
                  }
                </IconButton>
              }
            </>
            
          }
        >            
          <ListItemText 
            primary={
              <Box display="flex">
                <Box className="leftPrimaryTxt" style={{width:(props.main.showSetup?.MAP_LOCATION == 'show'?'55%':'80%'), fontSize:'14px'}}
                  onClick={()=>{if(exhibitor['booth'] != ''){ onClickItem(resolveBoothForRow(exhibitor), exhibitor);}}}
                >
                  {                   
                    exhibitor['title'] !='' && <div> {exhibitor.title} </div>
                  }
                  <div>
                  {                   
                    exhibitor['company'] !='' && ` ${exhibitor.company}`                    
                  }
                  </div>
                  <div>
                  {
                    exhibitor['DATE'] !=undefined && exhibitor['DATE'] !='' && 
                    `Event Date:${exhibitor.DATE.split('/')[0]}/${exhibitor.DATE.split('/')[1]}/${exhibitor.DATE.split('/')[2].slice(-2)}
                    ${exhibitor.start_time.split(' ')[0]}-${exhibitor.end_time} ${exhibitor.timezone}`
                  }
                  </div>
                </Box>

                {
                  props.main.showSetup ?.MAP_LOCATION == 'show' &&

                  <Box className="leftPrimaryTxt" style={{width:'25%', textAlign:'center'}}
                    onClick={()=>{onClickItem(resolveBoothForRow(exhibitor), exhibitor);}} 
                  >
                    {(exhibitor.MAP_NAME?(` ${exhibitor.MAP_NAME}`):"")}
                  </Box>
                }

                <Box pl={1} style={{width:'20%', fontSize:14.5, color: "#505050", textAlign:'center'}}
                  onClick={
                    ()=>{
                      let exhibitor_map_key = exhibitor.MAP_KEY
                      const active_booth_file = props.main.active_booth_file
                      if(active_booth_file && active_booth_file.KEY_ID == exhibitor_map_key){                         
                      }
                      else{
                        switchMap(exhibitor)
                        return;
                      }    
                      if(exhibitor['booth'] != ''){
                        setActiveObject(resolveBoothForRow(exhibitor), props.main, true, props.role == "admin"?false:(props.ui.openBoothList));
                      } else{
                        setActiveObject(exhibitor.obj, props.main, true, props.role == "admin"?false:(props.ui.openBoothList));                  
                      }
                    }
                  } 
                >
                  {
                    exhibitor['booth'] ==''  && <img src={exhibitor.img_url} width={35} height={35} style={{textAlign:'center', position: 'absolute', top: '5px', right: '80px'}}/>
                  }
                  { exhibitor['booth'] !=''  && <b style={{textAlign:'center'}}>{(exhibitor.name?exhibitor.name:"")}</b>}
                </Box>
              </Box>
            } 
          />
        </ListItem>
      );
    }
  }

    var listHeight = window.innerHeight - 110
    if(props.role == "admin"){
        listHeight = window.innerHeight - 168
    }
    var leftBoothList = props.ui.leftBoothList
    if(props.bookmark){
        leftBoothList = leftBoothList.filter((exhibitor)=>{
        return exhibitor.bookmark
        })
    }

    const getSearchOption = (value)=>{
      if (!value) return false;
      for(var i = 0; i < standardSearchOptions?.length; i++){
        if(standardSearchOptions[i].ID == value){
          return standardSearchOptions[i]
        }
      }
      return false
    }

    const doSearch=(data)=>{   
      var keyword = null
      let searchOption = getSearchOption(keySelect)
      {
        if(searchOption && searchOption.TYPE == 'pulldown'){
          keyword = pulldownValue
        }
        else{
          keyword = searchInputValue
        }
      }
      if(!keyword) keyword = ''
      keyword = `${keyword}`
      var filteredItems = data;
      
      if((keyword == "" || keyword == '""' || !keyword) && selectedAdvancedFilterOptions?.length === 0){
        return (filteredItems)
      }

      // duc
      if(props.curated==1){
        filteredItems = props.boothList;
      }
      
      if(keyword && keyword.trim() !== '') {
        filteredItems = filteredItems.filter((filteredItem)=>{ //data.filter //duc
          var item = filteredItem.obj
          if(!item) return false
          var str = ''
          if(keySelect == "company_description"){
            str = `${item.DESCRIPTION?item.DESCRIPTION:''}`
            return (str.toLowerCase().includes(keyword.toLowerCase()))
          }
          else if(keySelect == "exhibitor_name"){
            str = `${item.COMPANY_NAME?item.COMPANY_NAME:''}`
            return (str.toLowerCase().includes(keyword.toLowerCase()))
          }
          else if(keySelect == "Product Categories"){
            var categories = item.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            return (keys?.includes(keyword))
          }          
          else if(keySelect == "booth_number"){
            str = `${item.BOOTHS?item.BOOTHS:''}`
            return (str.toLowerCase().includes(keyword.toLowerCase()))
          }
          else if(keySelect == "map_name"){
            str = `${item.MAP_NAME?item.MAP_NAME:''}`
            return (str.toLowerCase().includes(keyword.toLowerCase()))
          }
          else if(keySelect == "state"){
            str = `${item.STATE?item.STATE:''}`
            return (str.toLowerCase()==(keyword.toLowerCase()))
          }
          else if(keySelect == "country"){
            str = `${item.COUNTRY?item.COUNTRY:'us'}`
            return (str.toLowerCase()==(keyword.toLowerCase()))
          }
          else if(keySelect == 'Featured Exhibitors'){
            str = `${item.FEATURED?item.FEATURED:''}`
            return (str.toLowerCase().includes(keyword.toLowerCase()))
          }
          else if(keySelect == "Region of Services"){
            var categories = item.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            return (keys?.includes(keyword))
          }     
          else if(keySelect == "Service Specialty"){
            var categories = item.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            return (keys?.includes(keyword))
          }             
          else{
            var categories = item.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            return (keys?.includes(keyword))
          }
        })      
      }
  
      if(selectedAdvancedFilterOptions?.length){
        let selectedFilter = selectedAdvancedFilterOptions[0]['key']
  
             
        if(selectedFilter?.includes("Region of Services")){
          filteredItems = filteredItems.filter((item)=>{
            var categories = item.obj?.CATEGORY;
              var keys = [];
              for(var i = 0; i< categories?.length; i++){
                keys.push(categories[i].ANSWER_KEY)
              }
              for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
                if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
                  return true;
                }
              }
              return false
          })
        }     
        else if(selectedFilter?.includes("Service Specialty")){
          filteredItems = filteredItems.filter((item)=>{
            var categories = item.obj?.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
              if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
                return true;
              }
            }
            return false
          })
        }  
        else {
          filteredItems = filteredItems.filter((item)=>{
            var categories = item.obj?.CATEGORY;
            var keys = [];
            for(var i = 0; i< categories?.length; i++){
              keys.push(categories[i].ANSWER_KEY)
            }
            for(var i = 0; i < selectedAdvancedFilterOptions?.length; i++){
              if(keys?.includes(selectedAdvancedFilterOptions[i]['value'])){
                return true;
              }
            }
            return false
          })
        }      
      }
      
      return filteredItems;
    }
    var title = props.title?props.title:'Searched Results'
    if(pulldownValue || searchInputValue){
      title = 'Searched Results'
    }
    let rowItems = doSearch(leftBoothList)
    const drawerWidth = Math.min(Math.max(440, Math.round(window.innerWidth*0.33)), window.innerWidth);
  
    return (
        <Fade in={true} timeout={1200}>
        <div> 
            <Box className='slideout-header' display="flex"  style={{justifyContent:'space-between', padding:'10px 48px 10px 16px', borderBottom:'1px solid #e0e0e0', background:props.ui?.customStyles?.['left-table-header-bg']?props.ui?.customStyles['left-table-header-bg']:'#4e7090', color:'white', alignItems:'center'}}>
                <Box style={{width: (props.main.showSetup?.MAP_LOCATION == 'show'?'48%':'76%'), textAlign:'left', paddingLeft: '0px'}}><b>{title}</b> <span style={{color:'#a0a0a0',  marginLeft:5}}>({rowItems?.length??0})</span></Box>
                {props.main.showSetup?.MAP_LOCATION == 'show' &&
                <Box style={{width: '28%', textAlign:'center', paddingLeft: '0px'}}><b>Location</b></Box>
                }
             <Box style={{width: '22%', textAlign:'center', paddingLeft: '0px'}}><b><LocationOnOutlinedIcon/></b></Box>
            </Box>
            {rowItems&&rowItems?.length>0?
            <FixedSizeList
                width={window.innerWidth >900?(drawerWidth-(props.role == 'admin'?0:72)):(window.innerWidth-40)}
                height={listHeight}
                rowCount={rowItems.length}
                //rowHeight={55}
                rowHeight={({ index }) => {
                  // calculate height based on the row's content or data
                  const item = rowItems[index];
                  if (item.DATE!=undefined && item.DATE!="" ) return 80;
                  else return 50; // default height
                }}
                rowRenderer={(param)=>rowRenderer({...param, rowItems})}
            >
            </FixedSizeList>:
            <Box style={{textAlign:'center', width:'100%'}}>
              <p>No Exhibitor Found.</p>
            </Box>
            }
            
        </div>
        </Fade>
    );
}

const mapStateToProps = (state) => {
  return {
    main: state.main,
    ui: state.ui,
    booth_history: state.booth_history.present,
    searchbox: state.searchbox,
  };
};

const mapDispatchProps = (dispatch) => {
  return { 
    setLeftPage: value=>dispatch(setLeftPage(value)) ,
    setOpenLogin: value=>dispatch(setOpenLogin(value)) ,
    setLeftBoothList:  data=>dispatch(setLeftBoothList(data)),
    setBookmardUpdated:  data=>dispatch(setBookmardUpdated(data)),
    setOpenCompanyProfile:  data=>dispatch(setOpenCompanyProfile(data)),
    setOpenUnassignedProfile:  data=>dispatch(setOpenUnassignedProfile(data)),
    setOpenBoothList: value=>dispatch(setOpenBoothList(value)) ,
    setActive3dObject: value=>dispatch(setActive3dObject(value)) ,
    setBookmarkList:  data=>dispatch(setBookmarkList(data)),
    setBoothFileList: data=>dispatch(setBoothFileList(data)), 
    resetUI: data=>dispatch(resetUI(data)), 
    resetMain: data=>dispatch(resetMain(data)),
    setActiveMapKey: value=>dispatch(setActiveMapKey(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
